module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-10.9d4a48ae.jpg";